<template>
    <main>
        <div class="modal fade" id="modalEvoluciones" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Listado de Evoluciones, Historia No: {{id_historia}}</h5>
                    <button type="button" class="close"  @click="cerrar();" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card mt-2 shadow-none"  v-if="isLoading">
                        <div class="card-body">
                          <content-placeholders :rounded="true">
                            <content-placeholders-heading :img="false" />
                            <content-placeholders-text :lines="3" />
                          </content-placeholders>
                        </div>
                    </div>
                    <div class="alert alert-warning mt-2" v-else-if="!evoluciones.length">
                        No existen evoluciones...
                    </div>
                    <div v-else class="card mt-2 border-gray-500 shadow-none" v-for="item in evoluciones" :key="item.id">
                        <div class="card-header bg-light ">
                            <div class="row">
                                <div class="col-4 ">
                                    Evolución No. {{item.id}} 
                                </div>
                                <div class="col-8 d-flex justify-content-end">
                                    {{item.fecha | formatDate}} {{item.hora | formatTime}}
                                    <button @click="imprimir(item.id);" class="btn btn-outline-info lift mx-2 shadow-sm btn-sm" >
                                        <i class="fa fa-print fa-fw"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body" >
                            <div class="row">
                                <div class="col-md-4 col-sm-12 col-lg-4">
                                    Profesional: <span class="text-danger">{{item.user.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light btn-sm" @click="cerrar();"><i class="far fa-times-circle fa-fw"></i> Cerrar</button>
                </div>
                </div>
            </div>
        </div>
        
    </main>
</template>
<script>

import urgenciaEvolucionService from '../../../../services/urgenciaEvolucionService';
import $ from "jquery";
export default {
    data(){
        return {
            id_historia:'',
            evoluciones:{},
            isLoading:true
        }
    },
    methods: {
        async  abrir(id){
            this.$nextTick(async () => {
                this.id_historia =id;
                $("#modalEvoluciones").modal("show");
                this.isLoading = true;
                const response = await urgenciaEvolucionService.showEvolucionByHc(id);
                this.evoluciones= response.data;
                this.isLoading = false;
            });
        },
        imprimir(id_evolucion){
            window.open(urgenciaEvolucionService.print(id_evolucion));
        },
        cerrar(){
            $("#modalEvoluciones").modal("hide");
            this.evoluciones= {};
        }
    },
}
</script>